// Constants describing the size of trie nodes.
const SHIFT = 5 // Resulted in best performance after ______?
const SIZE = 1 << SHIFT
const MASK = SIZE - 1

// Boolean references, Rough equivalent of `bool &`.
const MakeRef = () => ({ value: false })
const SetRef = ref => ref && (ref.value = true)

// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
// const OwnerID = () => {}
function OwnerID () {}

export {
  SHIFT,
  SIZE,
  MASK,
  MakeRef,
  SetRef,
  OwnerID
}
